import { httpClient } from '@/services/http/httpClient'

export type ResetPasswordParams = {
  token: string
  newPassword: string
}

export async function resetPassword({
  token,
  newPassword,
}: ResetPasswordParams): Promise<void> {
  await httpClient.post('/users/public/password-reset', {
    token,
    newPassword,
  })
}
